import { SectionHeader } from '@cox/core-ui8/dist/SectionHeader'

import { ReactSectionHeaderProps } from './types'
import withAEM from '../../hoc/withAEM'

const ReactSectionHeader = (props: ReactSectionHeaderProps): JSX.Element => {
  const { eyebrow, description, title, hideMCP = false, isInEditor = false } = props

  const eyebrowObj = {
    value: eyebrow,
    isRTE: true
  }
  const descriptionObj = {
    value: description,
    isRTE: true
  }
  const titleObj = {
    value: title,
    isRTE: true
  }
  const SectionHeaderWithAEM = withAEM(SectionHeader)
  return (
    <SectionHeaderWithAEM
      {...props}
      eyebrow={eyebrow && typeof eyebrow === 'string' ? eyebrowObj : eyebrow}
      description={description && typeof description === 'string' ? descriptionObj : description}
      title={title && typeof title === 'string' ? titleObj : title}
      hideMCP={hideMCP}
      isInEditor={isInEditor}
      compName={'Section Header'}
    />
  )
}
export default ReactSectionHeader
